import React, {useState} from 'react';
import Zoom from "react-reveal/Zoom";
import {useInView, useInViewEffect} from "react-hook-inview";


const ZoomWrapper = ({children, ...props}) => {
    // const [isVisible, setIsVisible] = useState(false)

    const [ref, inView] = useInView()


    return (
        <div ref={ref} className={'fadewrappper ' } >
            {/*<div style={{display: inView ? "block" : "none"}}>*/}


            <Zoom {...props} spy={inView} >{children}</Zoom>
            {/*</div>*/}
        </div>

    )
};


export default ZoomWrapper;
